import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

/**
 * El diálogo de pago no completado, hermano de ConfirmPayComponent: mismo
 * aspecto, pero sin nada que necesite sesión (Redsys puede devolver al usuario
 * a un dominio donde no la tiene).
 */
@Component({
  selector: 'app-payment-failed-dialog',
  templateUrl: './payment-failed-dialog.component.html',
  styleUrls: ['../confirm-pay/confirm-pay.component.scss', './payment-failed-dialog.component.scss']
})
export class PaymentFailedDialogComponent {

  eventSlug: string | null = null;

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data, private dialogRef: MatDialogRef<PaymentFailedDialogComponent>,
    private router: Router) {
    this.eventSlug = data?.eventSlug || null;
  }

  retry() {
    this.dialogRef.close();
    this.router.navigate(this.eventSlug ? ['/event', this.eventSlug] : ['/']);
  }

  close() {
    this.dialogRef.close();
  }
}
